import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import ConsumerSelect from '../DebtPaymentComponents/consumerSelect';
import BasicText from '../DebtPaymentComponents/basicText';
import {stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {CSSTransition} from 'react-transition-group';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {report, getReportParams} from '../../../../middleware/report';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentConsumerSelect = (props) => {
  const [mount, setMount] = useState(false);
  const [orgsList, setOrgsList] = useState(props.orgsList);
  const [payPendingStatus, setPayPendingStatus] = useState(false);

  useExtendedEffect(
    (runSideEffects) => {
      if (props.currentStep === stepEnum.CONSUMERSELECT && props.orgsList) {
        if (runSideEffects()) {
          setOrgsList(props.orgsList);
          if (props.orgsList.some((org) => org.payPendingStatus === true)) {
            setPayPendingStatus(true);
          }
          setMount(true);
          if (props.isPrivate) {
            gaEvent(
              gaParams.PRIVATEDEBT_CHOOSEACCOUNT_SHOW.category,
              gaParams.PRIVATEDEBT_CHOOSEACCOUNT_SHOW.eventType,
              props.orgsList.length,
            );
            let reportParams = getReportParams();
            reportParams.area = 'SelfCare';
            reportParams.subArea = 'Private Debt Payment';
            reportParams.channel = 'WebsitePrivate';
            reportParams.actionType = 'Debt List Page';
            reportParams.status = 'Ongoing';
            reportParams.messageText = 'Debt List Page Displayed';
            reportParams.subscriber = props.phoneNumber;
            reportParams.customerName = orgsList[0].name;
            const sum = orgsList.reduce((accumulator, object) => {
              return accumulator + object?.amount;
            }, 0);
            let sumPayments = 0;
            orgsList.forEach((element) => {
              if (element?.amount > 0 && element?.amount <= props.maxPaymentAmountPrivate) {
                sumPayments++;
              }
            });

            reportParams.param1 = `סהכ יתרה של כל החשבונות: ${sum}₪`;
            reportParams.param2 = `סהכ חשבונות שניתן לשלם: ${sumPayments}`;
            report(reportParams);
          } else {
            gaEvent(gaParams.DEBT_PAYMENT_SHOW_DEBTLIST.category, gaParams.DEBT_PAYMENT_SHOW_DEBTLIST.eventType, props.orgsList.length);
          }
        }
      } else {
        setMount(false);
      }
    },
    [props.currentStep, props.orgsList],
  );
  useEffect(() => {
    if (props.orgsList) setOrgsList(props.orgsList);
  }, [props.orgsList]);

  function getText() {
    if (!payPendingStatus) {
      return 'איזה חשבון תרצו לשלם?';
    }
    return 'ראינו שהיית באמצע תהליך תשלום חוב דרך bit';
  }

  return (
    <CSSTransition key={2} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={getText()} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        {!payPendingStatus && (
          <Row className='debtpayment-step-subtitle justify-content-md-center'>
            <Col md='auto'>
              <BasicText text={'אפשר לבחור חשבון אחד לתשלום בכל פעם.\nכדי להסדיר תשלום בחשבון נוסף, יש לחזור\nעל התהליך'} />
            </Col>
          </Row>
        )}
        <Container className='debtpayment-step-payment-box' fluid>
          {orgsList &&
            orgsList.map((ele) => (
              <ConsumerSelect
                key={ele.number}
                number={ele.number}
                monthlyBalance={ele.monthlyBalance}
                invoiceBalance={ele.invoiceBalance}
                amount={ele.amount}
                name={ele.name}
                isPrivate={props.isPrivate}
                isJetConnection={props.isJetConnection}
                activeJetBan={props.activeJetBan}
                maxAmountPrivate={props.maxPaymentAmountPrivate}
                productDescriptions={ele.productDescriptions}
                payPendingStatus={ele.payPendingStatus}
                onclick={() => {
                  let reportParams = getReportParams();
                  reportParams.area = 'SelfCare';
                  reportParams.subArea = 'Private Debt Payment';
                  reportParams.channel = 'WebsitePrivate';
                  reportParams.actionType = 'Debt List Page';
                  reportParams.status = 'Ongoing';
                  reportParams.messageText = 'Debt Clicked';
                  reportParams.subscriber = props.phoneNumber;
                  reportParams.param1 = `סה"כ יתרה: ${ele.amount}₪`;
                  reportParams.param2 = `חיוב עתידי: ${ele.invoiceBalance}₪`;
                  reportParams.param3 = `חוב: ${ele.monthlyBalance}₪`;
                  reportParams.customerName = orgsList[0].name;
                  report(reportParams);
                  props.onclick(ele);
                }}
              />
            ))}
        </Container>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentConsumerSelect;
